import { render, staticRenderFns } from "./Step3_resume.vue?vue&type=template&id=010153de&scoped=true"
import script from "./Step3_resume.vue?vue&type=script&lang=js"
export * from "./Step3_resume.vue?vue&type=script&lang=js"
import style0 from "./Step3_resume.vue?vue&type=style&index=0&id=010153de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010153de",
  null
  
)

export default component.exports